import { render, staticRenderFns } from "./PurchaseOrderBillsDetails.vue?vue&type=template&id=48ee43d0&scoped=true&"
import script from "./PurchaseOrderBillsDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderBillsDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderBillsDetails.vue?vue&type=style&index=0&id=48ee43d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ee43d0",
  null
  
)

export default component.exports